import app from '@frontastic/catwalk/src/js/app/app';
import clsx from 'clsx';
import React, { useRef, useMemo } from 'react';
import { useMedia } from 'react-use';

import useScrollMobile from '../../../../utils/useScrollMobile';
import Button from '../../../atoms/button';
import CloseCross from '../../../atoms/icons/CloseCross';
import Portal from '../../../atoms/portal';
import CreateAccount from '../../forms/createAccount';
import Login from '../../forms/login';
import styles from './AccountDropdown.module.scss';
import { useScrollLock } from '../../../../utils/useLockScroll';
import { useLogo } from '../../../../hooks/useLogo';
import { CartButton } from '../../../organisms/header/navigation/CartButton/CartButton';
import { theme } from '@srcDS/components/molecules/account/accountDropdown/_vars';

export const FORM_TYPE = {
  LOGIN: 'LOGIN',
  REGISTER: 'REGISTER',
};

const AccountDropdown = (
  {
    formName = FORM_TYPE.LOGIN,
    handleSetFormName,
    handleRegister,
    handleLogin,
    onCloseAction,
    isSticky,
    contentBlock,
    promo,
    showMarquee,
  },
) => {
  const ref = useRef();
  useScrollMobile(ref);
  const { logoUrl, title } = useLogo();
  const isMobile = useMedia('(max-width: 1024px)', false);
  const scrollTop = document
    .querySelector('#bodyWrapper > div')
    ?.getBoundingClientRect()?.top;
  const lockScroll = window.innerHeight <= 700;
  useScrollLock(lockScroll);

  const BackDrop = () => <div className={styles.backdrop} />;

  const logoActions = (e) => {
    e?.preventDefault();
    app.getRouter().history.push('/');
    onCloseAction();
  }

  const onClickAction = {
    onTouchEnd: (e) => logoActions(e),
    onClick: (e) => logoActions(e)
  };

  const renderAccountDropdown = useMemo(() => {
    return (
      <div
        ref={ref}
        className={clsx(
          styles.container,
          {
            [styles.sabaContainer]: theme === 'Saba',
            [styles.isShowMarquee]: showMarquee,
            [styles.isSticky]: isSticky,
            [styles.isScrolled]: scrollTop !== 0,
          }
        )}
      >
        <div className={styles.mobileHeader}>
          <Button ariaLabel="Close" variant="primary" as="text" onClick={onCloseAction}>
            <CloseCross
              width={theme !== 'Jag' ? '28' : '20'}
              height={theme !== 'Jag' ? '28' : '20'}
            />
          </Button>
          <div className={styles.headerLogo} {...onClickAction}>
            {logoUrl && (
              <img
                aria-label={title ?? 'logo'}
                src={logoUrl}
                alt={title ?? 'logo'}
                {...onClickAction}
              />
            )}
          </div>
          <CartButton
            placement="drawer"
            iconStyles={{
              width: 28,
              height: 28,
            }}
          />
        </div>
        {formName === FORM_TYPE.LOGIN && (
          <Login
            isPopup
            goToRegistrationAction={() => handleSetFormName(FORM_TYPE.REGISTER)}
            onLogin={handleLogin}
            onClose={onCloseAction}
            contentBlock={contentBlock}
            promo={promo}
          />
        )}
        {formName === FORM_TYPE.REGISTER && (
          <CreateAccount
            isPopup
            goToLoginAction={() => handleSetFormName(FORM_TYPE.LOGIN)}
            onCreate={handleRegister}
            onClose={onCloseAction}
            placement="popup"
            subtitle={promo}
          />
        )}
      </div>
    );
  }, [
    promo,
    contentBlock,
    onCloseAction,
    handleRegister,
    handleSetFormName,
    formName,
  ]);

  return (
    <>
      <div className={styles.overlay} onClick={onCloseAction} />
      {isMobile ? (
        renderAccountDropdown
      ) : (
        <Portal renderInto="openAccountPopup">
          <>
            <BackDrop />
            {renderAccountDropdown}
          </>
        </Portal>
      )}
    </>
  );
};

export default AccountDropdown;
